/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type RequestResetPasswordInput = {|
  email: string,
  userService?: ?boolean,
  clientMutationId?: ?string,
|};
export type requestResetPasswordMutationVariables = {|
  input: RequestResetPasswordInput
|};
export type requestResetPasswordMutationResponse = {|
  +requestResetPassword: ?{|
    +errors: ?$ReadOnlyArray<?string>,
    +success: ?boolean,
  |}
|};
export type requestResetPasswordMutation = {|
  variables: requestResetPasswordMutationVariables,
  response: requestResetPasswordMutationResponse,
|};
*/


/*
mutation requestResetPasswordMutation(
  $input: RequestResetPasswordInput!
) {
  requestResetPassword(input: $input) {
    errors
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "RequestResetPasswordInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RequestResetPasswordPayload",
    "kind": "LinkedField",
    "name": "requestResetPassword",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "requestResetPasswordMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "requestResetPasswordMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "requestResetPasswordMutation",
    "operationKind": "mutation",
    "text": "mutation requestResetPasswordMutation(\n  $input: RequestResetPasswordInput!\n) {\n  requestResetPassword(input: $input) {\n    errors\n    success\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3a8e63ad0db47147c7b45abda3983bff';

module.exports = node;
